import { useMask } from "@react-input/mask";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../../components/Box";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomSwitch from "../../../../components/CustomSwitch";
import { Helpers } from "../../../../helpers/Helpers";
import { GetCompanyByIdResponseCompanyAuthorizedPerson } from "../../../../models/response/company/GetCompanyByIdResponse";
import { storeAreYouSureModalCallback } from "../../../../redux/reducers/authSlice";
import { ConstantService } from "../../../../services/ConstantService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    authorizedPersonsInformationsRef: any
    companyAuthorizedPersons: GetCompanyByIdResponseCompanyAuthorizedPerson[]
    setCompanyAuthorizedPersons: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAuthorizedPerson[]>>
    canBeEdited: boolean
}

const AuthorizedPersonsInformations = ({
    authorizedPersonsInformationsRef,
    companyAuthorizedPersons,
    setCompanyAuthorizedPersons,
    canBeEdited
}: Props) => {
    const dispatch = useDispatch();
    const [companyAuthorizedPersonId, setCompanyAuthorizedPersonId] = useState('');
    const [authPersonName, setAuthPersonName] = useState<string | undefined>(undefined);
    const [authPersonSurname, setAuthPersonSurname] = useState<string | undefined>(undefined);
    const [selectedCompanyDepartment, setSelectedCompanyDepartment] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [authPersonPhone1, setAuthPersonPhone1] = useState<string | undefined>(undefined);
    const [authPersonPhone2, setAuthPersonPhone2] = useState<string | undefined>(undefined);
    const [email, setEmail] = useState<string | undefined>(undefined);
    const authPersonPhone1Ref = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });
    const authPersonPhone2Ref = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });
    const [authPersonDesc, setAuthPersonDesc] = useState<string | undefined>(undefined);
    const [authIsCustomActive, setAuthIsCustomActive] = useState(true);
    const [isOpen, setIsOpen] = useState(false);

    const saveItem = () => {
        if (Helpers.isEmpty(companyAuthorizedPersonId)) {
            var o: GetCompanyByIdResponseCompanyAuthorizedPerson = {
                departmentId: selectedCompanyDepartment?.value,
                departmentName: selectedCompanyDepartment?.label,
                description: authPersonDesc,
                name: authPersonName,
                phone1: authPersonPhone1,
                phone2: authPersonPhone2,
                surname: authPersonSurname,
                companyAuthorizedPersonId: Helpers.generateUUID(),
                isSelected: false,
                isCustomActive: authIsCustomActive,
                email: email
            }

            setCompanyAuthorizedPersons([...companyAuthorizedPersons, o])
        }
        else {
            setCompanyAuthorizedPersons(companyAuthorizedPersons.map(function (x) {
                if (x.companyAuthorizedPersonId == companyAuthorizedPersonId) {
                    x.departmentId = selectedCompanyDepartment?.value;
                    x.departmentName = selectedCompanyDepartment?.label;
                    x.description = authPersonDesc;
                    x.name = authPersonName;
                    x.phone1 = authPersonPhone1;
                    x.phone2 = authPersonPhone2;
                    x.surname = authPersonSurname;
                    x.isCustomActive = authIsCustomActive
                    x.isSelected = false;
                    x.email = email;
                }

                return x;
            }))
        }

        setCompanyAuthorizedPersonId('');
        setAuthPersonName('');
        setAuthPersonSurname('');
        setAuthIsCustomActive(true);
        setSelectedCompanyDepartment(undefined);
        setAuthPersonPhone1('');
        setAuthPersonPhone2('');
        setAuthPersonDesc('');
        setEmail('');
        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = companyAuthorizedPersons.filter(x => x.isSelected)[0];

        setCompanyAuthorizedPersonId(o.companyAuthorizedPersonId);

        setAuthPersonName(o.name);
        setAuthPersonSurname(o.surname);
        setAuthIsCustomActive(o.isCustomActive);

        if (o.departmentId)
            setSelectedCompanyDepartment({ label: o.departmentName + '', value: o.departmentId });

        setAuthPersonPhone1(o.phone1);
        setAuthPersonPhone2(o.phone2);
        setAuthPersonDesc(o.description);
        setEmail(o.email);
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setCompanyAuthorizedPersonId('');
        setAuthPersonName('');
        setAuthPersonSurname('');
        setAuthIsCustomActive(true);
        setSelectedCompanyDepartment(undefined);
        setAuthPersonPhone1('');
        setAuthPersonPhone2('');
        setAuthPersonDesc('');
        setEmail('');
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = authorizedPersonsInformationsRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const deleteItems = () => {
        setCompanyAuthorizedPersons(companyAuthorizedPersons.filter(x => !x.isSelected));
    }

    const selectAll = () => {
        var isAllSelected = companyAuthorizedPersons.length == companyAuthorizedPersons.filter(x => x.isSelected).length;

        setCompanyAuthorizedPersons(companyAuthorizedPersons.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setCompanyAuthorizedPersons(companyAuthorizedPersons.map(function (x) {
            if (x.companyAuthorizedPersonId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }
    return (
        <div className='containerPart' ref={authorizedPersonsInformationsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Yetkili Kişi Bilgileri</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Adı</label>
                                            <input value={authPersonName} onChange={(e) => setAuthPersonName(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Soyadı</label>
                                            <input value={authPersonSurname} onChange={(e) => setAuthPersonSurname(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                                            <input value={authPersonDesc} onChange={(e) => setAuthPersonDesc(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Departman</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCompanyDepartment}
                                                onChange={setSelectedCompanyDepartment}
                                                insertable={{
                                                    onSubmit: { code: 'COMPANY_DEPARTMENT' }
                                                }}
                                                onMenuOpen={() => ConstantService.getConstantList('COMPANY_DEPARTMENT')}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Cep Telefon</label>
                                            <input ref={authPersonPhone1Ref} style={{ border: '1px solid #F1F1F4' }} value={authPersonPhone1} onChange={(e) => setAuthPersonPhone1(e.target.value)} className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                            <CustomSwitch isActive={authIsCustomActive} setIsActive={setAuthIsCustomActive} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Sabit Telefon</label>
                                            <input ref={authPersonPhone2Ref} style={{ border: '1px solid #F1F1F4' }} value={authPersonPhone2} onChange={(e) => setAuthPersonPhone2(e.target.value)} className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">E-Posta</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="form-control form-control-solid" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={!canBeEdited ? undefined : cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} opacity={!canBeEdited ? "0.5" : "1"} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={!canBeEdited ? undefined : companyAuthorizedPersons.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={!canBeEdited ? "0.5" : companyAuthorizedPersons.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={!canBeEdited ? undefined : companyAuthorizedPersons.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={!canBeEdited ? "0.5" : companyAuthorizedPersons.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input disabled={!canBeEdited} onChange={selectAll} className='form-check-input' type='checkbox' checked={companyAuthorizedPersons.filter(x => x.isSelected).length > 0 && companyAuthorizedPersons.filter(x => x.isSelected).length == companyAuthorizedPersons.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Ad</th>
                                            <th>Soyad</th>
                                            <th>Departman</th>
                                            <th>Cep Telefon</th>
                                            <th>Sabit Telefon</th>
                                            <th>E-Posta</th>
                                            <th>Açıklama</th>
                                            <th>Durum</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            companyAuthorizedPersons.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            companyAuthorizedPersons.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input disabled={!canBeEdited} onChange={() => setItemSelected(item.companyAuthorizedPersonId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.name}</td>
                                                    <td>{item.surname}</td>
                                                    <td>{item.departmentName}</td>
                                                    <td>{item.phone1}</td>
                                                    <td>{item.phone2}</td>
                                                    <td>{item.email}</td>
                                                    <td>{item.description}</td>
                                                    <td>{item.isCustomActive ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default AuthorizedPersonsInformations;